const StatementTop = {
    template: /*html*/ `
  <div class="statement-top">
    <div :class="[amoutOfSteps, currentStep]" v-if="+stepAmount === 1">
      <div class="steps__item step step-1">
        <div class="steps__item-num"><span>1</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Паспортные данные</p>
        </div>
      </div>
    </div>

    <div :class="[amoutOfSteps, currentStep]" v-if="+stepAmount === 2">
      <div class="steps__item step step-1">
        <div class="steps__item-num"><span>1</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Паспортные данные</p>
        </div>
      </div>
      <div class="steps__item step step-2">
        <div class="steps__item-num"><span>2</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Информация о&nbsp;платеже</p>
        </div>
      </div>
    </div>

    <div :class="[amoutOfSteps, currentStep]" v-if="+stepAmount === 3">
      <div class="steps__item step step-1">
        <div class="steps__item-num"><span>1</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Паспортные данные</p>
        </div>
      </div>
      <div class="steps__item step step-2">
        <div class="steps__item-num"><span>2</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Информация о&nbsp;платеже</p>
        </div>
      </div>
      <div class="steps__item step step-3">
        <div class="steps__item-num"><span>3</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Проверка данных</p>
        </div>
      </div>
    </div>

    <div :class="[amoutOfSteps, currentStep]" v-if="+stepAmount === 4">
      <div class="steps__item step step-1">
        <div class="steps__item-num"><span>1</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Паспортные данные</p>
        </div>
      </div>
      <div class="steps__item step step-2">
        <div class="steps__item-num"><span>2</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Информация о&nbsp;платеже</p>
        </div>
      </div>
      <div class="steps__item step step-3">
        <div class="steps__item-num"><span>3</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Реквизиты для&nbsp;возврата</p>
        </div>
      </div>
      <div class="steps__item step step-4">
        <div class="steps__item-num"><span>4</span>
          <svg class="icon icon-steps-check-icon">
            <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#steps-check-icon'"></use>
          </svg>
        </div>
        <div class="steps__item-title">
          <p>Проверка данных</p>
        </div>
      </div>
    </div>
  </div>
  `,

    props: {
        activeStep: {
            type: Number || String,
            default: 1,
        },

        stepAmount: {
            type: Number || String,
            default: 1,
        },
    },

    computed: {
        currentStep() {
            return `current-step-${this.activeStep}`;
        },

        amoutOfSteps() {
            return `steps total-steps-${this.stepAmount}`;
        },
    },
};

export default StatementTop;
